<template>
  <div class="site-info">
    <div class="container clearfix">
      <div class="logo ir"></div>
      <div class="info-text">
        <p class="sites">
          <a href="http://www.zondarchina.com" >星中德汽车连锁</a>
          <span class="sep">|</span>
          <a href="" >杭州车管家数字科技</a>
          <span class="sep">|</span>
          <a href="" >绿城车管家</a>
          <span class="sep">|</span>
          <a href="" >幸福车生活</a>
          <span class="sep">|</span>
          <a href="" >车修修隐私政策</a>
          <span class="sep">|</span>
          <a href="" >车修修用户协议</a>
        </p>
        <p>
            ©
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=浙ICP备16033624号" target="_blank"  title="" stat_exposure="true"></a>浙ICP备16033624号
            
        </p>
      </div>
      
    </div>
    <!-- <div class="slogan ir"></div> -->
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.site-info {
  padding: 30px 0;
  font-size: 12px;
  background: #fafafa;
  .container{
    position: relative;
    width: 1226px;
    margin-right: auto;
    margin-left: auto;
    .logo{
      width: 57px;
      height: 57px;
      margin-right: 10px;
      // background: url(//s02.mifile.cn/assets/static/image/logo-footer.png) no-repeat 50% 50%;
      position: absolute;
      top: 0;
      left: 0;
    }
    .info-text{
      color: #b0b0b0;
      padding-left: 67px;
      p{
        margin: 0;
        line-height: 18px;
        .sites a{
          color: #757575;
        }
        .sep{
          margin: 0.25em;
          font-family: sans-serif;
        }
        a{
          color: #b0b0b0;
          &:hover{
            color: #f6700f;
          }
        }
      }
    }
    .info-links{
      height: 28px;
      margin: 4px 0 15px;
      padding-left: 67px;
      a{
        display: inline-block;
        margin-right: 5px;
        img{
          width: auto;
          height: 28px;
          margin-left: 0;
        }
      }
    }
  }
}
.site-info .slogan {
  clear: both;
  margin: 30px auto 0;
  width: 100%;
  height: 19px;
  background: url(https://cdn.cnbj1.fds.api.mi-img.com/staticsfile/global/slogan2020.png) no-repeat center 0;
}
</style>